import axios from 'axios';
import { usePortalStore } from '@/stores/portal.store';

const portalApi = axios.create({ baseURL: '/api/v1' });

portalApi.interceptors.request.use((config) => {
  const token = usePortalStore.getState().token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

portalApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      usePortalStore.getState().logout();
    }
    return Promise.reject(err);
  },
);

export default portalApi;
